import {createContext} from 'react';

export const RefreshContext = createContext({
    refreshData: false,
    setRefreshData: () => null
});

